import lod_ from "lodash";
import { Divider, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import MDBox from "components/Basics/MDBox";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import FormActions from "redux-react/actions/formAction";
import DeploymentActions from "redux-react/actions/deploymentActions";
import { t } from "i18next";
import DictionaryMenu from "pages/settings/filters/DictionaryMenu";
import MDButton from "components/Basics/MDButton";
import { queryDictionary } from "helpers/dictionary";
import DataCheckDialog from "./DataCheckDialog";

const BijectionTab = () => {
	const dispatch = useDispatch();

	/**
	 * Accounts
	 */
	// Options
	const [clients, setClients] = useState([]);
	// Selected one
	const [account, setAccount] = useState("");

	/**
	 * Assistants
	 */
	// Options
	const [assistants, setAssistants] = useState([]);
	// Selected one
	const [assistant, setAssistant] = useState(null);

	/**
	 * Resources
	 */
	const [resources, setResources] = useState([]);
	const [resource, setResource] = useState(null);
	const [resourceConfig, setResourceConfig] = useState({});

	const [anchorEl, setAnchorEl] = useState(null);
	const [dictionary, setDictionary] = useState({});
	const [path, setPath] = useState(null);

	const [dataCheckDialogOpen, setDataCheckDialogOpen] = useState(false);

	async function getAssistantsForAccount(accountID) {
		dispatch(
			DeploymentActions.getAssistantsForAccount(accountID, res => {
				setAssistants(res);
			})
		);
	}

	async function getAssistantResources(accountID, assistantID) {
		dispatch(
			DeploymentActions.getAssistantResources(accountID, assistantID, res => {
				setResources(res);
			})
		);
	}

	async function checkBijectionAssistantResource(path) {
		dispatch(
			DeploymentActions.checkBijectionAssistantResource(
				{
					accountID: account,
					assistantID: assistant,
					resource,
					path
				},
				resourceConfigRes => {
					setResourceConfig(resourceConfigRes);
				}
			)
		);
	}

	const getDictionary = async code => {
		const dictionaryResult = await queryDictionary(dispatch, code);
		setDictionary({ [code]: dictionaryResult });
	};

	useEffect(() => {
		dispatch(
			FormActions.getItemsFromCollection(
				"accountConfig",
				{
					catalog: "legacy",
					sort: "accountID"
				},
				({ items }) => {
					return setClients(items);
				}
			)
		);
	}, []);

	return (
		<MDBox mt={2} bgColor="white" p={1} borderRadius="md" display="flex" flexDirection="column">
			<MDBox display="flex" flexDirection="column" alignItems="center" sx={{ mt: 1 }}>
				{/* Assistant ID choice */}
				<MDBox display="flex" flexDirection="row" alignItems="center" sx={{ mt: 1, width: "100%" }}>
					{/*
					 * Account
					 */}
					<FormControl sx={{ flex: 1 }}>
						<InputLabel id="select-acconut">Account</InputLabel>
						<Select
							labelId="select-account"
							id="select"
							name="target"
							label="Account"
							value={account}
							onChange={e => setAccount(e.target.value)}
						>
							{clients.map((client, index) => (
								<MenuItem
									key={index}
									disabled={(client.assistants ?? []).length < 1}
									value={client.accountID}
									onClick={() => {
										// Reset
										setResources([]);
										setResource(null);
										setDictionary({});
										setPath(null);
										// Get
										getAssistantsForAccount(client.accountID);
									}}
								>
									{client.name ?? client.description ?? client.accountID}
								</MenuItem>
							))}
						</Select>
					</FormControl>
					{/*
					 * Assistant
					 */}
					<FormControl sx={{ flex: 1, ml: 1 }}>
						<InputLabel id="select-acconut">AssistantID</InputLabel>
						<Select
							disabled={account === ""}
							labelId="select-assistant"
							id="select"
							name="target"
							label="AssistantID"
							value={assistant}
							onChange={e => setAssistant(e.target.value)}
						>
							{assistants.map((assistant, index) => {
								return (
									<MenuItem
										key={index}
										value={assistant.assistantID}
										onClick={() => {
											// Reset
											setDictionary({});
											setPath(null);
											// Get
											getAssistantResources(account, assistant.assistantID);
										}}
									>
										{`${assistant.name} (${assistant.assistantID})`}
									</MenuItem>
								);
							})}
						</Select>
					</FormControl>
					{/*
					 * Resource
					 */}
					<FormControl sx={{ flex: 1, ml: 1 }}>
						<InputLabel id="select-acconut">Resources</InputLabel>
						<Select
							disabled={account === ""}
							labelId="select-resources"
							id="select"
							name="target"
							label="Resources"
							value={resource}
							onChange={e => setResource(e.target.value)}
						>
							{resources.map((resource, index) => {
								return (
									<MenuItem
										key={index}
										value={resource.code}
										onClick={() => {
											getDictionary(resource?.format?.dictionary);
										}}
									>
										{`${resource.name} (${resource.code})`}
									</MenuItem>
								);
							})}
						</Select>
					</FormControl>
				</MDBox>
				<Divider />
				<MDBox
					flex="1"
					sx={{ wifth: "100%" }}
					display="flex"
					flexDirection="column"
					alignItems="center"
					width="100%"
				>
					<MDButton
						variant="gradient"
						color="info"
						onClick={e => setAnchorEl(e.target)}
						disabled={lod_.isEmpty(dictionary)}
					>
						{t("SETTINGS.add")}
					</MDButton>
					<DictionaryMenu
						dictionary={dictionary}
						anchorEl={anchorEl}
						handleInsertText={path => {
							const pathWithoutFirstDot = path.split(".").slice(1).join(".");
							setPath(pathWithoutFirstDot);
							checkBijectionAssistantResource(pathWithoutFirstDot);
							setAnchorEl(null);
							setDataCheckDialogOpen(true);
						}}
						handleClose={() => setAnchorEl(null)}
						clickableLevels={false}
					/>

					<DataCheckDialog
						open={dataCheckDialogOpen}
						onClose={() => setDataCheckDialogOpen(false)}
						accountID={account}
						assistantID={assistant}
						resourceConfig={resourceConfig}
						data={{
							accountID: account,
							assistantID: assistant,
							resource,
							path
						}}
					/>
				</MDBox>
			</MDBox>
		</MDBox>
	);
};

export default BijectionTab;
